/* eslint-disable import/no-webpack-loader-syntax, no-underscore-dangle, no-console */
/* global SelectFx:false */
import 'imports-loader?this=>window&exports=>false&define=>false!lib/win/plugins';

$(document).ready(() => {
  if ($('.win-page-split').length === 0) {
    return;
  }

  RedirectUser();
  SortTermsSpacing();
  loadDropdown();
  loadCheckboxes();
  GetHeight();
  DomManipulation();
  $(window).resize(() => {
    GetHeight();
    DomManipulation();
  });

  // reload on partial postback
  const prm = Sys.WebForms.PageRequestManager.getInstance();
  if (prm != null) {
    prm.add_endRequest(sender => {
      if (sender._postBackSettings.panelsToUpdate != null) {
        // PleaseWaitSpinner(false);
        SortTermsSpacing();
        loadDropdown();
        loadCheckboxes();
        GetHeight();
        $(window).resize(() => {
          GetHeight();
        });
        RedirectUser();
        DomManipulation();
      }
    });

    prm.add_beginRequest(() => {
      PleaseWaitSpinner(true);
    });
  }
});

function SortTermsSpacing() {
  const $termsText = $('#win-terms-text .container p');
  if ($termsText.length > 0) {
    $termsText.html($termsText.html().replace(/\n/g, '<br />'));
  }
}

// Get required page height
function GetHeight() {
  if ($(".terms-btn-text:not('.js-ignore')").length) {
    $('form').css('height', '100%');
    $('#win-terms-text.open-terms').css('height', '100%');
    let height = 0;
    const termsHeight = $(".terms-btn-text:not('.js-ignore')").offset().top + 50;
    let selectHeight = 0;

    if ($('.cs-options').length > 0) {
      let dropHeight = $('.cs-options').height();
      if (dropHeight < 199) {
        dropHeight = 199;
      }
      selectHeight = $('.cs-options').offset().top + dropHeight + 40;
    }

    if (termsHeight > selectHeight) {
      height = termsHeight;
    } else {
      height = selectHeight;
    }

    if (height > $(window).outerHeight()) {
      // $("form").css("height", height);
      $('#win-terms-text').attr('data-height', height);
    } else {
      $('#win-terms-text').attr('data-height', '100%');
    }
  }
}

// Initialise select
function loadDropdown() {
  [].slice.call(document.querySelectorAll('select.cs-select')).forEach(el => {
    new SelectFx(el); // eslint-disable-line no-new
  });

  $('input, textarea').placeholder();
}

// Checkboxes
function loadCheckboxes() {
  const $checkboxes = $('input[type=checkbox]');
  $checkboxes.each(function each() {
    const $cb = $(this);
    const $label = $(`label[for=${$cb.attr('id')}]`);

    if ($label.length && $label.children('span').length === 0) {
      $label
        .wrapInner('<p></p>')
        .prepend('<span></span>')
        .addClass('checkLbl');

      $cb.change(() => {
        $label.toggleClass('checked');
      });

      if ($cb.is(':checked')) {
        $label.addClass('checked');
      }
    }
  });
}

function RedirectUser() {
  const $redir = $('.redirect-url');
  if ($redir.length > 0) {
    let n = 5000;
    const $countdown = $('.js-count');

    if ($countdown.length > 0) {
      $countdown.text(n / 1000);
    }

    const tm = setInterval(() => {
      n -= 1000;

      if ($countdown.length > 0) {
        $countdown.text(n / 1000);
      }

      if (n === 0) {
        if ($countdown.length > 0) {
          $countdown.text(n);
        }
        clearInterval(tm);
        window.location.href = $redir.text();
      }
    }, 1000);
  }
}

function DomManipulation() {
  if (!$('.win-page-split').length) {
    return;
  }

  const $leftCell = $('.left-cell');
  const $rightCell = $('.right-cell');
  if (matchMedia('(max-width: 768px)').matches) {
    $leftCell.insertAfter($rightCell);
  } else {
    $leftCell.insertBefore($rightCell);
  }

  if (!$('footer .win-terms').length) {
    $('.win-terms').appendTo('footer');
  } else {
    $rightCell.find('.win-terms').remove();
  }
}

// Show and hide please wait spinner
function PleaseWaitSpinner(showSpinner) {
  const spinner = $('.SubscriptionSpinner');
  const button = $('.SubscriptionButton');

  if (showSpinner) {
    $(spinner).show();
    $(button).hide();
  } else {
    $(spinner).hide();
    $(button).show();
  }
}
